import { queryOptions } from '@tanstack/react-query';
import { apiGet } from './apiClient';
import { ApiClientError } from './apiClient';

export interface Me {
  email: string;
}

/** Host identity bootstrap (04 /api/auth/me). Returns null when not signed in. */
export const meQuery = queryOptions({
  queryKey: ['auth', 'me'],
  queryFn: async (): Promise<Me | null> => {
    try {
      return await apiGet<Me>('/api/auth/me');
    } catch (err) {
      if (err instanceof ApiClientError && err.status === 401) return null;
      throw err;
    }
  },
  staleTime: 60_000,
});
